import { gql } from "@apollo/client";
import { PROJECT_FIELDS } from "../fragments";
import { graphql } from "../../gql/gql";

export const PROJECT_GET = gql`
  ${PROJECT_FIELDS}
  query Project($projectId: UUID!) {
    project(projectId: $projectId) {
      ...ProjectFields
    }
  }
`;

export const PROJECT_LIST = graphql(`
  query ProjectList {
    projectList {
      ...ProjectFields
      games {
        responseCount
      }
    }
  }
`);

export const DIRECTORY_LIST = graphql(`
  query DirectoryList {
    directoryList {
      ...DIRECTORY_FIELDS
      parentDirectory {
        ...DIRECTORY_FIELDS
      }
    }
  }
`);

export const PROJECT_PUBLIC = graphql(`
  query ProjectPublic($projectId: UUID!) {
    projectPublic(projectId: $projectId) {
      id
      public
      name
      games {
        id
        kind
        name
        responseCount
        configuration {
          ... on QuickRankConfiguration {
            id
            showRatingScale
          }
        }
        configuration {
          ... on RankifierConfiguration {
            id
          }
        }
        configuration {
          ... on SwiperConfiguration {
            id
          }
        }
        configuration {
          ... on WordopolisConfiguration {
            id
            showRatingScale
          }
        }
        configuration {
          ... on TriviaConfiguration {
            id
          }
        }
        configuration {
          ... on WordleConfiguration {
            id
          }
        }
      }
    }
  }
`);
